import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  setOfferInitData, setAACrossToken, setActiveRefundToken, setMagazineDatas,
} from './offerSlice';
import {
  initOffer, convertOfferData, aaCrossSubmit, activeRefundSubmit,
} from './offerUtils';
import { useLogTrackMutation } from '../../../store/services/common/logTrack/logTrackApi';

const useOfferWidgets = () => {
  const dispatch = useDispatch();

  const widgetNameSpace = useSelector(state => state.propsData.widgetNameSpace);
  const [ logTrack ] = useLogTrackMutation();

  const initOfferWidget = useCallback(({
    offerInitInfoResponse,
    bankRedirectSuccess,
    initOfferCallback,
  }) => {
    initOffer({
      widgetNameSpace,
      offerInitInfoResponse,
      bankRedirectSuccess,
    }).then((isOfferReady) => {
      if (isOfferReady) {
        const {
          offerInitData,
          activeRefundToken,
          AACrossToken,
          magazineDatas,
        } = convertOfferData({
          widgetNameSpace,
          offerInitInfoResponse,
          bankRedirectSuccess,
        });

        sessionStorage.setItem(`${widgetNameSpace}-initOfferParams`, JSON.stringify(offerInitData));
        dispatch(setOfferInitData(offerInitData));
        dispatch(setAACrossToken(AACrossToken));
        dispatch(setActiveRefundToken(activeRefundToken));
        dispatch(setMagazineDatas(magazineDatas));
      }
      initOfferCallback();
    });
  }, [ dispatch, widgetNameSpace ]);

  const submitOffers = useCallback(({ submitAaCrossToken, submitActiveRefundToken }) => {
    aaCrossSubmit(submitAaCrossToken, widgetNameSpace, logTrack);
    activeRefundSubmit(submitActiveRefundToken, widgetNameSpace, logTrack);
  }, [ widgetNameSpace, logTrack ]);

  return { initOfferWidget, submitOffers };
};

export default useOfferWidgets;
